import useModal from "../../hooks/useModal";
import { useMemo, useCallback } from "react";

const ExpandableText = ({ text, label = "Details", limit = 40 }) => {
  const { showModal } = useModal();

  const hasText = !!text;
  const lines = useMemo(
    () => (hasText ? text.split(/\r\n|\n/) : []),
    [hasText, text]
  );
  const hasMultipleLines = lines.length > 1;
  const isLong = hasText && text.length > limit;
  const shortText = hasText ? text.substring(0, limit) : "";
  const formattedText = useMemo(
    () => (hasText ? text.split(/\r\n|\n/).join("<br />") : "--"),
    [hasText, text]
  );
  const formattedShortText = useMemo(
    () => (hasText ? shortText.split(/\r\n|\n/).join("<br />") : ""),
    [hasText, shortText]
  );
  const handleReadMore = useCallback(() => {
    showModal(
      label,
      <div
        dangerouslySetInnerHTML={{
          __html: formattedText,
        }}
      />
    );
  }, [showModal, label, formattedText]);

  if (!hasText) return "--";

  if (hasMultipleLines) {
    return (
      <>
        <span>
          {lines[0].length > 40 ? lines[0].substring(0, 40) : lines[0]}
        </span>
        <button
          className="border-0 more readmore"
          style={{ backgroundColor: "transparent" }}
          onClick={handleReadMore}
        >
          [read more]
        </button>
      </>
    );
  }

  return (
    <>
      {isLong ? (
        <>
          <span
            dangerouslySetInnerHTML={{
              __html: formattedShortText,
            }}
          />
          <button
            className="border-0 more readmore"
            style={{ backgroundColor: "transparent" }}
            onClick={handleReadMore}
          >
            [read more]
          </button>
        </>
      ) : (
        <span
          dangerouslySetInnerHTML={{
            __html: formattedText,
          }}
        />
      )}
    </>
  );
};

export default ExpandableText;
